/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
export default {
	RESOURCE_MENU_IDS: {
		EDIT: 0,
		DELETE: 1,
		OPEN: 2,
		START: 3,
		STOP: 4,
		PAUSE: 5,
		EXPORT: 6,
		CLONE: 7,
		SET_TITLE_IMAGE: 8,
		RESET_TITLE_IMAGE: 9,
		SETTINGS: 10,
	}
};
